export default "__VITE_ASSET__DZBSDSAb__"